export const UserRating = {
	UNRATED: 1,
	NON_COMMERCIAL: 2,
	VALUED: 3,
	VIP: 4,
	WATCHLIST: 5,
	MBL: 6,
	BONUS_ABUSER: 7,
	TOUGH_SPORT: 8,
	TOUGH: 9,
	FEMALE: 10,
	TIPPING: 11,
	EARLY_LIFE_NURTURE: 12,
	EARLY_LIFE_UNSURE: 13,
	MARGINAL: 14,
	PREVIOUSLY_BET_STOPPED: 15
};

export const UserRatingName = {
	[UserRating.UNRATED]: 'Unrated',
	[UserRating.NON_COMMERCIAL]: 'Non-Commercial',
	[UserRating.VALUED]: 'Valued',
	[UserRating.VIP]: 'VIP',
	[UserRating.WATCHLIST]: 'Watchlist',
	[UserRating.MBL]: 'MBL',
	[UserRating.BONUS_ABUSER]: 'Bonus Abuser',
	[UserRating.TOUGH_SPORT]: 'Tough Sport',
	[UserRating.TOUGH]: 'Tough',
	[UserRating.FEMALE]: 'Female',
	[UserRating.TIPPING]: 'Tipping Service',
	[UserRating.EARLY_LIFE_NURTURE]: 'Early Life Nurture',
	[UserRating.EARLY_LIFE_UNSURE]: 'Early Life Unsure',
	[UserRating.MARGINAL]: 'Marginal',
	[UserRating.PREVIOUSLY_BET_STOPPED]: 'Previously Bet Stopped'
};

export const UserRatingColours = {
	[UserRating.UNRATED]: { bg: 'bg-purple-500', text: 'text-white' },
	[UserRating.NON_COMMERCIAL]: { bg: 'bg-gray-500', text: 'text-white' },
	[UserRating.VALUED]: { bg: 'bg-green-600', text: 'text-white' },
	[UserRating.VIP]: { bg: 'bg-yellow-500', text: 'text-dark' },
	[UserRating.WATCHLIST]: { bg: 'bg-blue-200', text: 'text-dark' },
	[UserRating.MBL]: { bg: 'bg-red-500', text: 'text-white' },
	[UserRating.BONUS_ABUSER]: { bg: 'bg-black', text: 'text-white' },
	[UserRating.TOUGH_SPORT]: { bg: 'bg-red-500', text: 'text-white' },
	[UserRating.TOUGH]: { bg: 'bg-red-500', text: 'text-white' },
	[UserRating.FEMALE]: { bg: 'bg-pink-300', text: 'text-dark' },
	[UserRating.TIPPING]: { bg: 'bg-blue-800', text: 'text-white' },
	[UserRating.EARLY_LIFE_NURTURE]: { bg: 'bg-green-600', text: 'text-white' },
	[UserRating.EARLY_LIFE_UNSURE]: { bg: 'bg-purple-500', text: 'text-white' },
	[UserRating.MARGINAL]: { bg: 'bg-orange-500', text: 'text-white' },
	[UserRating.PREVIOUSLY_BET_STOPPED]: { bg: 'bg-lime-500', text: 'text-white' }
};

export const UserSubRating = {
	GOLD: 1,
	SILVER: 2,
	BRONZE: 3,
	STANDARD: 4
};

export const UserSubRatingName = {
	[UserSubRating.GOLD]: 'Gold',
	[UserSubRating.SILVER]: 'Silver',
	[UserSubRating.BRONZE]: 'Bronze',
	[UserSubRating.STANDARD]: 'Standard'
};

export const UserSubRatingColours = {
	[UserSubRating.GOLD]: { bg: 'bg-yellow-500', text: 'text-white' },
	[UserSubRating.SILVER]: { bg: 'bg-gray-500', text: 'text-white' },
	[UserSubRating.BRONZE]: { bg: 'bg-orange-800', text: 'text-white' },
	[UserSubRating.STANDARD]: { bg: 'bg-blue-500', text: 'text-white' }
};

export const UserStage = {
	EARLY_LIFE: 1,
	EARLY_LIFE_LAPSING: 2,
	EARLY_LIFE_LAPSED: 3,
	IN_LIFE: 4,
	IN_LIFE_LAPSING: 5,
	LAPSED: 6,
	NURTURE_RETURNER: 7
};

export const UserStageName = {
	[UserStage.EARLY_LIFE]: 'Early Life',
	[UserStage.EARLY_LIFE_LAPSING]: 'Early Life Lapsing',
	[UserStage.EARLY_LIFE_LAPSED]: 'Early Life Lapsed',
	[UserStage.IN_LIFE]: 'In Life',
	[UserStage.IN_LIFE_LAPSING]: 'In Life Lapsing',
	[UserStage.LAPSED]: 'Lapsed',
	[UserStage.NURTURE_RETURNER]: 'Nurture Returner'
};

export const UserStageColours = {
	[UserStage.EARLY_LIFE]: { bg: 'bg-green-600', text: 'text-white' },
	[UserStage.EARLY_LIFE_LAPSING]: { bg: 'bg-orange-800', text: 'text-white' },
	[UserStage.EARLY_LIFE_LAPSED]: { bg: 'bg-red-500', text: 'text-white' },
	[UserStage.IN_LIFE]: { bg: 'bg-green-600', text: 'text-white' },
	[UserStage.IN_LIFE_LAPSING]: { bg: 'bg-orange-800', text: 'text-white' },
	[UserStage.LAPSED]: { bg: 'bg-red-500', text: 'text-white' },
	[UserStage.NURTURE_RETURNER]: { bg: 'bg-gray-500', text: 'text-white' }
};

export const AccountTypes = {
	CLIENT: 1,
	TEST: 2,
	BETBACK: 3
};

export const UserRatingBoostBlacklist = [UserRating.NON_COMMERCIAL, UserRating.MBL, UserRating.BONUS_ABUSER];

export const UserRatingBonusBlacklist = [UserRating.NON_COMMERCIAL, UserRating.MBL, UserRating.BONUS_ABUSER];

export const UserRatingPromoBlacklist = [];

export const TwoFactorTypes = {
	SMS: 1,
	Email: 2,
	TOTP: 3
};

export const UserStatus = {
	Closed: 1,
	Active: 2,
	Locked: 3,
	Suspended: 4,
	Banned: 5,
	'Self Excluded': 6,
	Break: 7,
	'Bet Stopped': 8
};

export const UserStatusName = {
	[UserStatus.Closed]: 'Closed',
	[UserStatus.Active]: 'Active',
	[UserStatus.Locked]: 'Locked',
	[UserStatus.Suspended]: 'Suspended',
	[UserStatus.Banned]: 'Banned',
	[UserStatus['Self Excluded']]: 'Self Excluded',
	[UserStatus.Break]: 'Break',
	[UserStatus['Bet Stopped']]: 'Bet Stopped'
};
